if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.#mount();
		}

		#mount(){

			/* -- > DRAWERS < -- */

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header'
				stickyHeader.setAttribute('data-js-inert', '');
				stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
					${this.querySelector('.header__bottom').innerHTML}
				</div>
				<div class="site-header header__top container--large">
					${this.querySelector('.header__top').innerHTML}
				</div>`;
				document.body.append(stickyHeader);
				this._stickyHeaderEl = stickyHeader;

				if ( this.querySelector('.button--cart-handle') && stickyHeader.querySelector('.header-actions') ) {
					stickyHeader.querySelector('.header-actions').append(this.querySelector('.button--cart-handle').cloneNode(true));
				}

				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('[aria-controls]').forEach(elm=>{
					if ( ! ( elm.hasAttribute('data-js-sidebar-handle') || elm.hasAttribute('data-modal') ) ) {
						elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
					}
				})

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound = this.querySelector('.header__bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');

				const stickyHeaderMayRemoveShowOnScrollDown = ()=>{
					return ! this._headerMobileSearchExpanded;
				};

				this.SCROLL_StickyHelper = () =>{
					
					var st = window.scrollY;
					try {
						if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
							stickyHeader.classList.remove('show');
							return;
						}

						if ( st < 0 || Math.abs(lst - st) <= 5 )
							return;	

						if ( st > window.lhp ) {

							if ( st === 0 && stickyHeader.classList.contains('show') ) {

								stickyHeader.classList.remove('show');

							} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

								window.lhp = stickyHeader.offsetTop;
								if ( ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top : stickyHeaderMobileBound.getBoundingClientRect().top ) < -100 ) {
									stickyHeader.classList.add('show');
								}

							} else if ( st > lst && stickyHeader.classList.contains('show') ) {
								if ( stickyHeaderMayRemoveShowOnScrollDown() ) {
									stickyHeader.classList.remove('show');
								}
							}

						}
					} finally {
						window.lst = st;
					}

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});

					stickyHeader.querySelectorAll('.submenu-masonry').forEach(elm=>{
						let columns = 4;
						if ( elm.classList.contains('with-2-promotions') ) {
							columns = 2;
						} else if ( elm.classList.contains('with-promotion') ) {
							columns = 3;
						}
						if ( elm.dataset.columns ) {
							columns = parseInt(elm.dataset.columns);
						}
						const trigger = elm.closest('.has-submenu');
						if ( ! trigger ) return;
						// Build MiniMasonry on first open (relayout on later opens) inside rAF, once
						// the menu is visible — measuring a hidden menu produced inconsistent gaps.
						let masonry = null;
						const layoutMasonry = () => requestAnimationFrame(() => {
							if ( typeof MiniMasonry === 'undefined' ) return;
							const width = elm.clientWidth;
							if ( ! width ) return;
							if ( masonry ) masonry.destroy();
							elm.classList.add('masonry-active');
							masonry = new MiniMasonry({
								container: elm,
								baseWidth: Math.floor(width / columns),
								gutter: 0,
								surroundingGutter: false,
								direction: document.documentElement.getAttribute('dir') === 'rtl' ? 'rtl' : 'ltr'
							});
							elm.querySelectorAll('img').forEach(img => {
								if ( ! img.complete ) {
									img.addEventListener('load', () => { if ( masonry ) masonry.layout(); }, { once: true });
								}
							});
						});
						trigger.addEventListener('mouseenter', layoutMasonry);
						trigger.addEventListener('focusin', layoutMasonry);
					});
				
			} else {
				this._stickyHeaderEl = null;
			}

			// drawer cart connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elmSidebar?.show(elm);
					})
				}
			})
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode === window.KEYCODES.ESC ) {
					const activeDialog = document.querySelector('modal-box.active[role="dialog"]');
					if ( document.querySelector('.sidebar--opened') && ! activeDialog ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
			}`;

			// Inert elements

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('inert-inside') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Init modal windows

			document.querySelectorAll('[aria-controls="modal-store-selector"]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode === window.KEYCODES.RETURN ) {
						window.lastFocusedElm = elm;
					}
				})
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
					if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
						document.getElementById(elm.getAttribute('aria-controls')).show();
					}
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode === window.KEYCODES.RETURN ) {
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					}
				})
			});

			// Submenu alignment

			const rtl = document.documentElement.getAttribute('dir') === 'rtl';
			document.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm=>{
				elm.addEventListener('mouseover', ()=>{
					if ( elm.querySelector('.normal-menu') ) {
						elm.querySelector('.normal-menu').style.left = `${rtl ? elm.getBoundingClientRect().right : elm.getBoundingClientRect().left}px`;
					}
				})
			});

			// predictive search

			const bindPredictiveSearchInputListeners = elm=>{
				if ( ! elm ) {
					return;
				}
				elm.addEventListener('focus', ()=>{
					const overlay = document.getElementById(elm.dataset.jsFocusOverlay);
					if ( overlay ) {
						overlay.classList.add('active');
					}
					if ( ! document.body.classList.contains('predictive-script-loaded') ) {
						document.body.classList.add('predictive-script-loaded')
						const predictiveSearchJS = document.createElement('script');
						predictiveSearchJS.src = KROWN.settings.predictive_search_script;
						document.head.appendChild(predictiveSearchJS); 
					}
				})
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode === window.KEYCODES.TAB ) {
						const desktopOverlay = document.getElementById('search-results-overlay-desktop');
						if ( desktopOverlay && desktopOverlay.classList.contains('active') ) {
							desktopOverlay.classList.remove('active');
						}
					}
				})
			};

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
				document.querySelectorAll('search-form [data-js-search-input]').forEach(bindPredictiveSearchInputListeners)
				window.addEventListener('load', ()=>{
					document.querySelectorAll('.search-results-overlay').forEach(elm=>{
						elm.style = '';
					})
				});
			} else {
				document.querySelector('search-form [data-js-search-input] + button').classList.add('button--invisibile-trigger');
			}

			// mobile search: reveal on first click, focus on every click (independent per header)

			const mobileSearchSource = this.querySelector('[data-header-mobile-search-panel]');
			const mobileSearchToggles = document.querySelectorAll('[data-header-mobile-search-toggle]');
			this._headerMobileSearchExpanded = false;
			if ( mobileSearchSource && mobileSearchToggles.length ) {

				let mainRevealed = false;
				let stickyRevealed = false;

				const revealMainSearch = ()=>{
					if ( mainRevealed ) {
						return;
					}
					mainRevealed = true;
					this._headerMobileSearchExpanded = true;
					mobileSearchSource.classList.remove('hide');
				};

				const revealStickySearch = ()=>{
					if ( stickyRevealed || ! this._stickyHeaderEl ) {
						return;
					}
					stickyRevealed = true;
					this._headerMobileSearchExpanded = true;
					const clone = mobileSearchSource.cloneNode(true);
					clone.classList.remove('hide');
					clone.setAttribute('data-header-mobile-search-clone', '');
					this._stickyHeaderEl.appendChild(clone);
					clone.querySelectorAll('[id]').forEach(elm=>{
						elm.id = `${elm.id}-sticky`;
					});
					clone.querySelectorAll('[data-js-focus-overlay]').forEach(elm=>{
						const ref = elm.getAttribute('data-js-focus-overlay');
						if ( ref ) {
							elm.setAttribute('data-js-focus-overlay', `${ref}-sticky`);
						}
					});
					if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
						bindPredictiveSearchInputListeners(clone.querySelector('[data-js-search-input]'));
					}
				};

				mobileSearchToggles.forEach(btn=>{
					btn.addEventListener('click', e=>{
						e.preventDefault();
						const fromSticky = this._stickyHeaderEl && btn.closest('.sticky-header');
						if ( fromSticky ) {
							revealStickySearch();
							const input = this._stickyHeaderEl.querySelector('[data-header-mobile-search-panel] input[type=search]');
							if ( input ) {
								input.focus();
							}
						} else {
							revealMainSearch();
							const input = mobileSearchSource.querySelector('input[type=search]');
							if ( input ) {
								input.focus();
							}
						}
						btn.setAttribute('aria-expanded', 'true');
					});
				});
			}

			this._headerSearchQNameSync = e=>{
				if ( e.target.tagName !== 'INPUT' || e.target.name !== 'q' ) {
					return;
				}
				if ( ! e.target.closest('#site-header') && ! e.target.closest('.sticky-header') ) {
					return;
				}
				const enterCode = window.KEYCODES ? window.KEYCODES.RETURN : 13;
				const enterInit = { key: 'Enter', code: 'Enter', keyCode: enterCode, which: enterCode, bubbles: true, cancelable: true };
				document.querySelectorAll('#site-header input[name="q"], .sticky-header input[name="q"]').forEach(el=>{
					if ( el !== e.target ) {
						el.value = '';
						el.dispatchEvent(new KeyboardEvent('keydown', enterInit));
						el.dispatchEvent(new KeyboardEvent('keyup', enterInit));
					}
				});
			};
			document.body.addEventListener('input', this._headerSearchQNameSync);

			// touch navigation for the menu

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
						const trigger = elm.querySelector(':scope > a[aria-controls]');
						trigger?.setAttribute('aria-expanded', 'false');
						document.getElementById(trigger?.getAttribute('aria-controls'))?.setAttribute('aria-hidden', 'true');
					}
				})
			}
			const bindTouchMenuTrigger = (item, parentItem = null)=>{
				const trigger = item.querySelector(':scope > a.menu-link[aria-controls]');
				const menu = trigger ? document.getElementById(trigger.getAttribute('aria-controls')) : null;
				if ( ! trigger ) return;

				trigger.addEventListener('pointerdown', event=>{
					trigger.dataset.pointerType = event.pointerType;
				});

				trigger.addEventListener('click', event=>{
					const pointerType = trigger.dataset.pointerType;
					delete trigger.dataset.pointerType;
					if ( pointerType !== 'touch' && pointerType !== 'pen' ) return;

					if ( ! item.classList.contains('focus') ) {
						event.preventDefault();
						item.classList.add('focus');
						trigger.setAttribute('aria-expanded', 'true');
						menu?.setAttribute('aria-hidden', 'false');
						closeTouchSubmenus(item, parentItem);
					}
				});
			};

			document.querySelectorAll('.style--classic .has-babymenu').forEach(item=>{
				bindTouchMenuTrigger(item, item.closest('.has-submenu'));
			});
			document.querySelectorAll('.style--classic .has-submenu:not(.mega-link)').forEach(item=>{
				bindTouchMenuTrigger(item);
			});

			// keyboard navigation for the menu

			const setClassicMenuState = (item, trigger, menu, expanded)=>{
				item.classList.toggle('focus', expanded);
				trigger.setAttribute('aria-expanded', String(expanded));
				menu?.setAttribute('aria-hidden', String(!expanded));

				if ( ! expanded ) {
					item.querySelectorAll('.has-babymenu.focus').forEach(babyItem=>{
						babyItem.classList.remove('focus');
						const babyTrigger = babyItem.querySelector(':scope > a[aria-controls]');
						babyTrigger?.setAttribute('aria-expanded', 'false');
						document.getElementById(babyTrigger?.getAttribute('aria-controls'))?.setAttribute('aria-hidden', 'true');
					});
				}
			};

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a[aria-controls]').forEach(trigger=>{
				const item = trigger.parentNode;
				const menu = document.getElementById(trigger.getAttribute('aria-controls'));
				menu?.setAttribute('aria-hidden', 'true');

				trigger.addEventListener('keydown', event=>{
					if ( event.key === 'Enter' || event.key === ' ' ) {
						event.preventDefault();
						setClassicMenuState(item, trigger, menu, !item.classList.contains('focus'));
					} else if ( event.key === 'ArrowDown' ) {
						event.preventDefault();
						setClassicMenuState(item, trigger, menu, true);
						menu?.querySelector('a, button')?.focus();
					} else if ( event.key === 'Escape' ) {
						event.preventDefault();
						setClassicMenuState(item, trigger, menu, false);
					}
				});

				item.addEventListener('focusout', event=>{
					if ( ! item.contains(event.relatedTarget) ) {
						setClassicMenuState(item, trigger, menu, false);
					}
				});
			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a[aria-controls]').forEach(trigger=>{
				const item = trigger.parentNode;
				const menu = document.getElementById(trigger.getAttribute('aria-controls'));
				menu?.setAttribute('aria-hidden', 'true');

				trigger.addEventListener('keydown', event=>{
					if ( event.key === 'Enter' || event.key === ' ' ) {
						event.preventDefault();
						setClassicMenuState(item, trigger, menu, !item.classList.contains('focus'));
					} else if ( event.key === 'ArrowRight' || event.key === 'ArrowDown' ) {
						event.preventDefault();
						setClassicMenuState(item, trigger, menu, true);
						menu?.querySelector('a, button')?.focus();
					} else if ( event.key === 'Escape' || event.key === 'ArrowLeft' ) {
						event.preventDefault();
						setClassicMenuState(item, trigger, menu, false);
						trigger.focus();
					}
				});

				item.addEventListener('focusout', event=>{
					if ( ! item.contains(event.relatedTarget) ) {
						setClassicMenuState(item, trigger, menu, false);
					}
				});
			});

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
			if ( this._headerSearchQNameSync ) {
				document.body.removeEventListener('input', this._headerSearchQNameSync);
			}
		}

	}
	
  if ( typeof customElements.get('main-header') === 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			this.addEventListener('keydown', event=>{
				if ( ! this.opened || event.key !== 'Tab' ) {
					return;
				}

				const focusableElements = Array.from(this.querySelectorAll(
					'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
				)).filter(element=>{
					const rect = element.getBoundingClientRect();
					return rect.width > 0 && rect.height > 0 && element.getAttribute('aria-hidden') !== 'true';
				});

				if ( focusableElements.length === 0 ) {
					event.preventDefault();
					this.focus();
					return;
				}

				const firstElement = focusableElements[0];
				const lastElement = focusableElements[focusableElements.length - 1];
				const focusIsOutside = ! this.contains(document.activeElement);

				if ( event.shiftKey && ( document.activeElement === firstElement || focusIsOutside ) ) {
					event.preventDefault();
					lastElement.focus();
				} else if ( ! event.shiftKey && ( document.activeElement === lastElement || focusIsOutside ) ) {
					event.preventDefault();
					firstElement.focus();
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(opener = document.activeElement){

			if ( this.opened ) {
				return;
			}

			this.opened = true;
			this._opener = opener instanceof HTMLElement ? opener : null;
			if ( this._opener?.getAttribute('aria-controls') === this.id ) {
				this._opener.setAttribute('aria-expanded', 'true');
			}
			this.removeAttribute('aria-hidden');
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
				this.querySelector('[data-js-close]')?.focus();
			}, 15);
			if ( this.id === "site-cart-sidebar" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
				window.lalaLoadDeferredCartWallets?.(this);
			}

		}

		hide(restoreFocus = true){

			if ( ! this.opened ) {
				return;
			}

			this.opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach(opener => opener.setAttribute('aria-expanded', 'false'));
			const opener = this._opener;
			this._opener = null;

			setTimeout(()=>{
				this.style.display = 'none';
				this.setAttribute('aria-hidden', 'true');
				if ( restoreFocus ) opener?.focus();
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') === 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof ScrollableNavigation !== 'function' ) {

	class ScrollableNavigation extends HTMLElement {

		constructor() {

			super();

			this.linkList = this.querySelector('.link-list');
			this.header = this.parentNode;
			window.addEventListener('resize', debounce(()=>{
				this.#checkNav();
			}, 200));
			this.#checkNav();

			const rtl = document.documentElement.getAttribute('dir') === 'rtl';

			this.parentNode.querySelector('.scrollable-navigation-button--left').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft - (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
			this.parentNode.querySelector('.scrollable-navigation-button--right').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft + (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})

		}

		#checkNav() {
			if ( this.linkList.scrollWidth > this.offsetWidth ) {
				this.header.classList.add('scrolling-navigation-enabled');
			} else {
				this.header.classList.remove('scrolling-navigation-enabled');
			}
		}
		
	}

  if ( typeof customElements.get('scrollable-navigation') === 'undefined' ) {
		customElements.define('scrollable-navigation', ScrollableNavigation);
	}

}

(() => {
	const oldBebetoCertificate = 'lala-sweets-kervan-bebeto-halal-certificate-compliance-2024.png?v=1783379185';
	const currentBebetoCertificate = 'lala-sweets-kervan-bebeto-soft-candy-halal-certificate-2024.png?v=1783379200';
	const currentBebetoUrl = 'https://cdn.shopify.com/s/files/1/0856/5705/9662/files/' + currentBebetoCertificate;

	const replaceStaleCertificate = () => {
		document.querySelectorAll('a[href*="' + oldBebetoCertificate + '"], img[src*="' + oldBebetoCertificate + '"]').forEach((element) => {
			if (element.tagName === 'A') {
				element.href = currentBebetoUrl;
				element.setAttribute('aria-label', 'Kervan Bebeto Soft Candy Halal Zertifikat vergrössern');
			}
			if (element.tagName === 'IMG') {
				element.src = currentBebetoUrl;
				element.alt = 'Kervan Bebeto Halal Zertifikat gültig bis 10.09.2027';
			}
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', replaceStaleCertificate, { once: true });
	} else {
		replaceStaleCertificate();
	}
})();
